import React, { useState } from 'react';

/* MobX */
// import { observer } from 'mobx-react-lite';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { Grid, TextField, Button } from '@material-ui/core';
import MuiPhoneNumber from "material-ui-phone-number";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const CreateUser = props => {
  const classes = useStyles();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");

  return (
    <div className={classes.paper}>
      <form autoComplete="off" noValidate >
        <Grid container spacing={2}>
          <Grid item xs={6} align="center">
            <TextField name="firstName" label="First Name" variant="outlined" required fullWidth value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </Grid>
          <Grid item xs={6} align="center">
            <TextField name="lastName" label="Last Name" variant="outlined" required fullWidth value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </Grid>
          <Grid item xs={6} align="center">
            <TextField name="email" label="Email" variant="outlined" required fullWidth value={email} onChange={(e) => setEmail(e.target.value)} />
          </Grid>
          <Grid item xs={6} align="center">
            <MuiPhoneNumber variant="outlined" required fullWidth defaultCountry={'us'} regions={['north-america', 'central-america']} countryCodeEditable={false}
              value={phone} onChange={(value) => setPhone(value)} />
          </Grid>
          <Grid item xs={12} align="center">
            <TextField name="address" label="Address" variant="outlined" required fullWidth value={address} onChange={(e) => setAddress(e.target.value)} />
          </Grid>
          <Grid item xs={12} align="center">
            <TextField name="username" label="Username" variant="outlined" required fullWidth value={username} onChange={(e) => setUsername(e.target.value)} />
          </Grid>
          <Grid item xs={6} align="center">
            <TextField name="password" label="Password" variant="outlined" required fullWidth value={password} onChange={(e) => setPassword(e.target.value)} />
          </Grid>
          <Grid item xs={6} align="center">
            <TextField name="confirmPassword" label="Repeat Password" variant="outlined" required fullWidth value={rePassword} onChange={(e) => setRePassword(e.target.value)} />
          </Grid>
          <Grid item xs={12} align="center">
            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>Submit</Button>
          </Grid>
        </Grid>
      </form>
    </div>
  )
};

export default CreateUser;